import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

const CTABand = () => {
  const nav = useNavigate();
  return (
    <section className="bg-white py-20">
      <div className="max-w-[1100px] mx-auto px-6">
        <div className="relative rounded-3xl bg-gradient-to-br from-[#0F2A5F] via-[#0F2A5F] to-[#14B8A6] overflow-hidden p-10 md:p-14">
          <div className="absolute -top-24 -right-16 w-80 h-80 rounded-full bg-white/10 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-16 -left-16 w-72 h-72 rounded-full bg-white/5 blur-3xl pointer-events-none" />

          <div className="relative flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
            <div>
              <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white text-xs font-semibold uppercase tracking-widest px-3 py-1.5 rounded-full mb-5">
                <Sparkles size={13} /> Get started free
              </div>
              <h2
                className="text-3xl md:text-[40px] font-extrabold text-white leading-tight mb-3"
                style={{ fontFamily: "'Open Sans', sans-serif" }}
              >
                Be part of the digital revolution.
              </h2>
              <p className="text-white/80 text-lg">
                Get your clinic account in a minute — no credit card needed.
              </p>
            </div>
            <button
              onClick={() => nav("/register")}
              className="inline-flex items-center gap-2 bg-white text-[#0F2A5F] font-bold px-7 py-4 rounded-xl hover:bg-slate-100 transition-colors shadow-xl flex-shrink-0"
            >
              Register Now <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABand;
